import { useMemo } from 'react';

import {
  type DataWarehouseRefFragment,
  type GraphQLAppError,
  getError,
  getTypeOrNull,
  useDataWarehousesQuery,
} from '@spotify/confidence-graphql';

import { findPrimaryWarehouse } from '../../helpers/findPrimaryWarehouse';
import { isConfidenceCloudWarehouse } from '../../helpers/isConfidenceCloudWarehouse';

export type UseDataWarehousesResult = {
  warehouses: DataWarehouseRefFragment[];
  primaryWarehouse: DataWarehouseRefFragment | undefined;
  isLoading: boolean;
  error: GraphQLAppError | null;
};

export const useDataWarehouses = (options?: {
  skip?: boolean;
  writable?: boolean;
}): UseDataWarehousesResult => {
  const { data, loading } = useDataWarehousesQuery({ skip: options?.skip });

  const warehouses: DataWarehouseRefFragment[] = useMemo(() => {
    const active = (
      getTypeOrNull(data?.dataWarehouses)?.dataWarehouses ?? []
    ).filter(warehouse => !warehouse.deleteTime);

    if (options?.writable) {
      return active.filter(
        warehouse => !isConfidenceCloudWarehouse(warehouse.name),
      );
    }

    return active;
  }, [data, options?.writable]);

  return {
    warehouses,
    primaryWarehouse: findPrimaryWarehouse(warehouses),
    isLoading: loading,
    error: getError(data?.dataWarehouses),
  };
};
